<template>
  <div class="page page-reality-rank">
    <div class="page__inner">
      <r-cup-bar :cup-id="realityCupId" />
      <div class="k-tabs col-2 skin-2" id="rank-cup__tabs">
        <ul>
          <li class="k-tabs__item r-eid-rrTabMy">
            <router-link tag="a" to="/reality/games">我的记录</router-link>
          </li>
          <li class="k-tabs__item active  r-eid-rrTabRank">
            <router-link tag="a" to="/reality/rank">排行榜</router-link>
            </li>
        </ul>
      </div>

    
      <div class="sect-wrap">
        <final-rank-score v-if="realityCupId > 0" :cup-id="realityCupId" />
      </div>
      
    </div>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import RankScore from './rank-score'
  export default {
    components: {
      [RankScore.name]: RankScore
    },
    computed: {
      ...mapGetters(['realityCupId']),
      ...mapGetters('reality', ['rankList'])
    },
    methods: {
      ...mapActions(['loadRealityCupId']),
      // ...mapActions('match', ['loadFinalRank']),
      ...mapActions('reality', ['loadCup', 'loadCupPlayer']),
    },
    async created() {
      let cupId = this.realityCupId
      if(!cupId) {
        await this.loadRealityCupId()
        cupId = this.realityCupId
      }
      await this.loadCup({cupId})
      await this.loadCupPlayer({cupId})
      // await this.loadFinalRank({
      //   page: 1,
      //   pageNum: 500
      // })
    }
  };

</script>
